var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#005DAA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4343 18.7657C14.7467 19.0781 15.2533 19.0781 15.5657 18.7657L18.7657 15.5657C19.0781 15.2533 19.0781 14.7467 18.7657 14.4343C18.4533 14.1219 17.9467 14.1219 17.6343 14.4343L15.8 16.2686L15.8 8.8C15.8 8.35817 15.4418 8 15 8C14.5582 8 14.2 8.35817 14.2 8.8L14.2 16.2686L12.3657 14.4343C12.0533 14.1219 11.5467 14.1219 11.2343 14.4343C10.9219 14.7467 10.9219 15.2533 11.2343 15.5657L14.4343 18.7657ZM9.44444 14C9.44444 13.5984 9.12109 13.2727 8.72222 13.2727C8.32335 13.2727 8 13.5984 8 14V19.8182C8 20.3969 8.22827 20.9518 8.6346 21.361C9.04093 21.7701 9.59203 22 10.1667 22H19.8333C20.408 22 20.9591 21.7701 21.3654 21.361C21.7717 20.9518 22 20.3969 22 19.8182V14C22 13.5984 21.6767 13.2727 21.2778 13.2727C20.8789 13.2727 20.5556 13.5984 20.5556 14V19.8182C20.5556 20.0111 20.4795 20.1961 20.344 20.3325C20.2086 20.4688 20.0249 20.5455 19.8333 20.5455H10.1667C9.97512 20.5455 9.79142 20.4688 9.65598 20.3325C9.52054 20.1961 9.44444 20.0111 9.44444 19.8182V14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.ef1a04e74fd72b9001fe66c05b8fae9b.svg";
export { ForwardRef as ReactComponent };